/* eslint-disable react/jsx-key */
"use client";

import Plus from "@/public/svg/plus.svg";

import Heading from "@/components/heading/heading"

import Image from "next/image";

import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from "react-accessible-accordion";

// Demo styles, see 'Styles' section below for some notes on use.
import "react-accessible-accordion/dist/fancy-example.css";
import './accordion.scss'
import { ReactNode } from "react";

interface FaqProps {
    data: {
        question: string;
        answer: string;
        listItems: string[];
    }[];
}

export default function Accordian(props: FaqProps) {
    const { data } = props;
    return (
        <Accordion allowZeroExpanded={true}>
            {data?.map((item, index) => {
                return (
                    <AccordionItem key={index}>
                        <AccordionItemHeading>
                            <AccordionItemButton>
                                <Heading as="h4">{item.question}</Heading>
                                <Image loading="lazy"
                                    src={Plus}
                                    alt="Plus"
                                    width={16}
                                    height={16}
                                    
                                />
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <p className="lead">{item.answer}</p>
                            {item.listItems ?
                                <ul className="lead list-disc ml-10 my-4">
                                    {item.listItems.map((listItem, index) =>
                                        <li key={index}>{listItem}</li>)}
                                </ul> : ""}
                        </AccordionItemPanel>
                    </AccordionItem>
                );
            })}
        </Accordion>
    );
}
